var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('task-delivery-instagram-story-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var campaign = ref.campaign;
    var contact = ref.contact;
    var proposal = ref.proposal;
    var task = ref.task;
    var job = ref.job;
    var errorMessage = ref.errorMessage;
    var isLoading = ref.isLoading;
    var deliverStoryUrl = ref.deliverStoryUrl;
    var deliverInsightsUrl = ref.deliverInsightsUrl;
    var uploadHeaders = ref.uploadHeaders;
    var isJobDelivered = ref.isJobDelivered;
    var handleInsightsFileChange = ref.handleInsightsFileChange;
    var handleStoryFileChange = ref.handleStoryFileChange;
    var jobHasInsights = ref.jobHasInsights;
    var handleStartConnection = ref.handleStartConnection;
    var hasUploadedFiles = ref.hasUploadedFiles;
    var uploadedFiles = ref.uploadedFiles;
    var handleReloadProposal = ref.handleReloadProposal;
return [_c('task-delivery-instagram-story-view',{attrs:{"campaign":campaign,"contact":contact,"proposal":proposal,"task":task,"job":job,"is-loading":isLoading,"error-message":errorMessage,"deliver-story-url":deliverStoryUrl,"deliver-insights-url":deliverInsightsUrl,"upload-headers":uploadHeaders,"is-job-delivered":isJobDelivered,"job-has-insights":jobHasInsights,"has-uploaded-files":hasUploadedFiles,"uploaded-files":uploadedFiles},on:{"story-file-change":handleStoryFileChange,"insights-file-change":handleInsightsFileChange,"start-connection":handleStartConnection,"reload-proposal":handleReloadProposal}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }